// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a:focus {
    border: none;
}

.container {
    margin: 0 10px 0 10px;    
}

.conteudo-superior-row {
    display: flex;
    justify-content: space-between;
    padding-bottom: 0.25rem;
}

.pagina-titulo {
    font-family: UniSansThin;
    font-style: normal;
    font-weight: 250;
    font-size: 20px;
    line-height: 24px;
    color: var(--pAzul);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Consulta/style.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB","sourcesContent":["a:focus {\n    border: none;\n}\n\n.container {\n    margin: 0 10px 0 10px;    \n}\n\n.conteudo-superior-row {\n    display: flex;\n    justify-content: space-between;\n    padding-bottom: 0.25rem;\n}\n\n.pagina-titulo {\n    font-family: UniSansThin;\n    font-style: normal;\n    font-weight: 250;\n    font-size: 20px;\n    line-height: 24px;\n    color: var(--pAzul);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
